module.exports = __webpack_public_path__ + "static/media/icon_176.7861d958.svg";